import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
}

export default colors
